import { createAjv, JsonFormsCore } from '@jsonforms/core';
import React, { useState } from 'react';
import { CustomerItem } from '../../services/api/types';
import { FormCard } from './FormCard';
import validator from 'validator';

import custSchema from './forms/schemas/customer/schema.json';
import custUiSchema from './forms/schemas/customer/uischema.json';

export interface CustomerContextProps {
  data: CustomerItem;
  onSave(data: any): void;
  onChange?(state: Pick<JsonFormsCore, 'data' | 'errors'>): void;
}

const handleAjv = createAjv();
const validateCustomerName: any = (customerschema: any, data: any) => {
  let isValid = true;
  let msg = '';
  const patternNotallowSpecialChar = new RegExp('^[A-Za-z ]+$');
  if (!data) {
    isValid = false;
    msg = 'Customer Name cannot be blank';
  } else if (!patternNotallowSpecialChar.test(data)) {
    isValid = false;
    msg = 'Special characters are not allowed';
  }
  validateCustomerName.errors = [
    {
      keyword: 'validateCustomerName',
      message: msg,
      params: { keyword: 'validateCustomerName' },
    },
  ];
  return isValid;
};
handleAjv.addKeyword({
  validate: validateCustomerName,
  errors: true,
  keyword: 'validateCustomerName',
});

const validateCustomerPhoneNumber: any = (customerschema: any, data: any) => {
  let isValid = true;
  const patternOnlyNumber = new RegExp('^([0-9]{10})?$');
  let msg = '';
  if (!data || !patternOnlyNumber.test(data)) {
    isValid = false;
    msg = 'Please enter a 10 digit phone number';
  }
  validateCustomerPhoneNumber.errors = [
    {
      keyword: 'validateCustomerPhoneNumber',
      message: msg,
      params: { keyword: 'validateCustomerPhoneNumber' },
    },
  ];
  return isValid;
};

handleAjv.addKeyword({
  validate: validateCustomerPhoneNumber,
  errors: true,
  keyword: 'validateCustomerPhoneNumber',
});

const validateCustomerEmail: any = (customerschema: any, data: any) => {
  let isValid = true;
  let msg = '';
  if (data && !validator.isEmail(data)) {
    isValid = false;
    msg = 'Please enter a valid Email Address';
  }
  validateCustomerEmail.errors = [
    {
      keyword: 'validateCustomerEmail',
      message: msg,
      params: { keyword: 'validateCustomerEmail' },
    },
  ];
  return isValid;
};

handleAjv.addKeyword({
  validate: validateCustomerEmail,
  errors: true,
  keyword: 'validateCustomerEmail',
});

export const Customer = ({ onSave, data, onChange }: CustomerContextProps) => {
  const [isEdit, setEditState] = useState(false);
  const [props, setProps] = useState<any>(data);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [isvalid, setIsvalid] = useState<boolean>(false);

  const editHandler = (state: boolean) => {
    if (state && !isvalid) {
      setFormSubmitted(true);
    } else {
      setFormSubmitted(false);
    }
    setEditState(state);
  };

  const saveHandler = (custData: any) => {
    if (onSave) {
      setFormSubmitted(true);
      onSave(custData);
      setFormSubmitted(false);
    }
    setEditState(false);
  };

  const _changeHandler = (state: Pick<JsonFormsCore, 'data' | 'errors'>) => {
    let valid = true;
    if (state && state.errors && state.errors.length) {
      valid = false;
    }
    if (state.data) {
      setProps(state.data);
    }
    if (onChange) {
      onChange(state);
    }
    setIsvalid(valid);
  };

  const onKeyPress = (event: any) => {
    if (event.key === 'Enter' && event.target.type !== 'textarea') {
      setFormSubmitted(true);
      if (isvalid) {
        saveHandler(props);
      }
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form onKeyUp={onKeyPress}>
      <div
        className={`${formSubmitted ? 'formSubmitted' : ''} ${
          isvalid ? 'isvalid' : 'notvalid'
        }`}
      >
        <FormCard
          data={data}
          title="Customer"
          onSave={saveHandler}
          uischema={custUiSchema}
          schema={custSchema}
          onEdit={editHandler}
          isReadonly={isEdit ? false : true}
          onChange={_changeHandler}
          ajv={handleAjv}
        />
      </div>
    </form>
  );
};
